import * as C from '../../constants';
import * as Catalog from '../catalog';
import * as Cart from '../cart';
import * as Pagination from '../pagination';
import * as Faq from '../faq';
import * as DataGatePage from '../dataGatePage';
import * as Plans from '../plans';
import * as BuyShopItemState from '../buyShopItem';
import * as Favourite from '../favourite';
import { getEntitySelector } from '../../selectors';

export const getCartItemCount = (state: RootState) =>
  Cart.getCartItemCount(state.cart);

export const getDataItems = (state: RootState) =>
  getIsFilterDataItems(state) ? [] : getDataItemSearchResults(state);

export const getShopItems = (state: RootState) =>
  getIsFilterShopItems(state) ? [] : getShopItemSearchResults(state);

export const getShopItemCategories = (state: RootState) =>
  getIsFilterShopItemCategories(state)
    ? []
    : getShopItemCategorySearchResults(state);

export const getIsFilterShopItems = (state: RootState) =>
  Catalog.isFilterShopItems(state.catalog);

export const getIsFilterDataItems = (state: RootState) =>
  Catalog.isFilterDataItems(state.catalog);

export const getIsFilterShopItemCategories = (state: RootState) =>
  Catalog.isFilterShopItemCategories(state.catalog);

export const getFocusedDataItemId = (state: RootState) =>
  Catalog.getFocusedDataItemId(state.catalog);

export const getFocusedShopItemId = (state: RootState) =>
  Catalog.getFocusedShopItemId(state.catalog);

export const getCatalogIsUserSearch = (state: RootState) =>
  Catalog.isUserSearch(state.catalog);

export const getFocusedDataItem = (state: RootState) =>
  Catalog.getFocusedDataItemId(state.catalog) &&
  getEntitySelector(state).dataItem.getFullById(
    Catalog.getFocusedDataItemId(state.catalog)
  );

export const getFocusedShopItem = (state: RootState) =>
  Catalog.getFocusedShopItemId(state.catalog) &&
  getEntitySelector(state).shopItem.getFullById(
    Catalog.getFocusedShopItemId(state.catalog)
  );

export const getSearchResultCount = (state: RootState) =>
  getShopItemSearchResults(state).length +
  getDataItemSearchResults(state).length +
  getShopItemCategorySearchResults(state).length;

export const getLastSearchQuery = (state: RootState) =>
  Catalog.getLastSearchQuery(state.catalog);

export const getIsSearchingCatalog = (state: RootState) =>
  Catalog.isSearchingCatalog(state.catalog);

export const getCartDataItems = (state: RootState) =>
  getCartItemsByKey(state)(C.CART_KEY.DATA_ITEM);

export const getCartShopItemCategories = (state: RootState) =>
  getCartItemsByKey(state)(C.CART_KEY.SHOP_ITEM_CATEGORY);

export const getCartShopItemCategoriesFull = (state: RootState) =>
  getEntitySelector(state).shopItemCategory.getFullByIds(
    getCartShopItemCategories(state)
  );

export const getCartDataItemsFull = (state: RootState) =>
  getEntitySelector(state).dataItem.getFullByIds(getCartDataItems(state));

export const getCartShopItems = (state: RootState) =>
  getCartItemsByKey(state)(C.CART_KEY.SHOP_ITEM);

export const getCartShopItemsFull = (state: RootState) =>
  getEntitySelector(state).shopItem.getFullByIds(getCartShopItems(state));

export const getDataItemSearchResults = (state: RootState) =>
  getIsFilterDataItems(state)
    ? []
    : getEntitySelector(state).dataItem.allFullBySearchResults();

export const getShopItemSearchResults = (state: RootState) =>
  getIsFilterShopItems(state)
    ? []
    : getEntitySelector(state).shopItem.allFullBySearchResults();

export const getShopItemCategorySearchResults = (state: RootState) =>
  getIsFilterShopItemCategories(state)
    ? []
    : getEntitySelector(state).shopItemCategory.allFullBySearchResults();

export const getCartItems = (state: RootState) => Cart.getCartItems(state.cart);

export const getCartItemsByKey = (state: RootState) => (key: string) =>
  Cart.getCartItemsByKey(state.cart)(key);

export const getPaginationByKey = (state: RootState) => (key: string) =>
  Pagination.getPaginationByKey(state.pagination)(key);

const getPaginationPageByKey = (state: RootState) => (key: string) =>
  Pagination.getPaginationPageByKey(state.pagination)(key);

const getPaginationSizeByKey = (state: RootState) => (key: string) =>
  Pagination.getPaginationSizeByKey(state.pagination)(key);

const getPaginationSliceByKey = (state: RootState) => (key: string) =>
  Pagination.getPaginationSliceByKey(state.pagination)(key);

export const getDataItemPaginationPage = (state: RootState) =>
  getPaginationPageByKey(state)(C.PAGINATION.DATA_ITEM);

export const getDataItemsPaginationSlice = (state: RootState) =>
  getPaginationSliceByKey(state)(C.PAGINATION.DATA_ITEM);

export const getDataItemsPaginationSize = (state: RootState) =>
  getPaginationSizeByKey(state)(C.PAGINATION.DATA_ITEM);

export const getShopItemPaginationPage = (state: RootState) =>
  getPaginationPageByKey(state)(C.PAGINATION.SHOP_ITEM);

export const getShopItemsPaginationSlice = (state: RootState) =>
  getPaginationSliceByKey(state)(C.PAGINATION.SHOP_ITEM);

export const getShopItemsPaginationSize = (state: RootState) =>
  getPaginationSizeByKey(state)(C.PAGINATION.SHOP_ITEM);

export const getShopItemCategoryPaginationPage = (state: RootState) =>
  getPaginationPageByKey(state)(C.PAGINATION.SHOP_ITEM_CATEGORY);

export const getShopItemCategoryPaginationSlice = (state: RootState) =>
  getPaginationSliceByKey(state)(C.PAGINATION.SHOP_ITEM_CATEGORY);

export const getShopItemCategoryPaginationSize = (state: RootState) =>
  getPaginationSizeByKey(state)(C.PAGINATION.SHOP_ITEM_CATEGORY);

export const getCatalogFaq = (state: RootState) =>
  Faq.getFAQByView(state.faq)(C.VIEWS.PAYMENT);

export const getFAQErrorState = (state: RootState) =>
  Faq.getFAQErrorState(state.faq);

// TODO: use selector for i18n.translations
export const getDataGatePageMyChannels = (state: RootState) =>
  DataGatePage.getDataGatePageMyChannels(state.dataGatePage)(
    state.i18n.translations
  );

// TODO: use selector for i18n.translations
export const getDataGatePagePublicChannels = (state: RootState) =>
  DataGatePage.getDataGatePagePublicChannels(state.dataGatePage)(
    state.i18n.translations
  );

// TODO: use selector for i18n.translations
export const getDataGatePagePrivateChannels = (state: RootState) =>
  DataGatePage.getDataGatePagePrivateChannels(state.dataGatePage)(
    state.i18n.translations
  );

export const getRequireRecurringPayment = (state: RootState) =>
  getCartDataItems(state).length + getCartShopItemCategories(state).length > 0;

export const getSelectedPlanKey = (state: RootState) =>
  Plans.getSelectedPlanKey(state.plans);

export const getMonthlyCostPerMonth = (state: RootState) =>
  Plans.getMonthlyCostPerMonth(state.plans);

export const getYearlyCostPerMonth = (state: RootState) =>
  Plans.getYearlyCostPerMonth(state.plans);

export const getYearlyCostPerYear = (state: RootState) =>
  Plans.getYearlyCostPerYear(state.plans);

export const getYearlyCostSavings = (state: RootState) =>
  Plans.getYearlyCostSavings(state.plans);

export const getTrialCost = (state: RootState) =>
  Plans.getTrialCost(state.plans);

export const getTrialDuration = (state: RootState) =>
  Plans.getTrialDuration(state.plans);

export const getPlanTotalCost = (state: RootState) =>
  Plans.getTotalCost(state.plans);

export const getRecurringCostPayableToday = (state: RootState) =>
  Plans.getRecurringCostPayableToday(state.plans);

export const getNonRecurringCostPayableToday = (state: RootState) =>
  Plans.getNonRecurringCostPayableToday(state.plans);

export const getPlanIsFetching = (state: RootState) =>
  Plans.getPlanIsFetching(state.plans);

const getLastSelectedShopItemId = (state: RootState) =>
  BuyShopItemState.getLastSelectedShopItemId(state.buyShopItem);

export const getLastSelectedShopItem = (state: RootState): ShopItem | null =>
  getLastSelectedShopItemId(state) > 0
    ? getEntitySelector(state).shopItem.getFullById(
        getLastSelectedShopItemId(state)
      ) || null // for now
    : null;

export const getFavouriteDataItemIds = (state: RootState) =>
  Favourite.getFavouriteDataItemIds(state.favourite);

export const getFavouriteShopItemIds = (state: RootState) =>
  Favourite.getFavouriteShopItemIds(state.favourite);



// WEBPACK FOOTER //
// ./app/reducers/selectors/index.ts